import React, { useCallback } from "react";
import { Platform } from "react-native";
import { graphql, useFragment } from "react-relay";
import { BaseWidgetProps } from "../BaseProps";

import { NoteWeb } from "./NoteWeb";
import { NoteNative } from "./NoteNative";
import { WidgetNote_widgetNote$key } from "./__generated__/WidgetNote_widgetNote.graphql";
import { useSetWidgetFocus } from "../useSetFocus";

export { WidgetNotePageBackground } from "./WidgetNotePageBackground";
export { WidgetNoteStyleLegcyToNewBG } from "./styleHelpers/useNoteWidgetStyle";

export const WidgetNote = (
  props: {
    widget: WidgetNote_widgetNote$key;
    pageId?: string;
    clientTitle?: string;
    isRenderedFromOrg?: boolean;
  } & BaseWidgetProps
) => {
  const { widget: widgetKey, ...rest } = props;

  const widget = useFragment(
    graphql`
      fragment WidgetNote_widgetNote on WidgetNote {
        id
        note {
          editingMode
          isOrgNote
          pages {
            id
          }
          ...NoteWeb_note
          ...NoteNative_note
        }
      }
    `,
    widgetKey
  );

  const focus = useSetWidgetFocus(widget.id, props.storecastId);

  const onPageChange = useCallback(
    (id: string) => {
      if (props.mode === "FOCUS" && props.isFocused) {
        focus(id);
      }
    },
    [focus, props.isFocused, props.mode]
  );

  const onPagePress = useCallback(
    (pageId: string) => {
      if (props.mode === "FOCUS" && !props.isFocused) {
        focus(pageId);
      } else {
        if (
          widget.note.editingMode === "DEFAULT" &&
          (props.isRenderedFromOrg || !widget.note.isOrgNote)
        ) {
          props.onEvent?.({
            kind: "NoteSelect",
            widgetId: widget.id,
            pageId,
          });
        }
      }
    },
    [props, focus, widget.note.editingMode, widget.note.isOrgNote, widget.id]
  );

  if (Platform.OS === "web" && props.idiom === "STATIC") {
    return (
      <NoteWeb
        note={widget.note}
        interactive={props.interactive}
        isRenderedFromOrg={props.isRenderedFromOrg}
        pageId={props.pageId}
      />
    );
  }
  return (
    <NoteNative
      note={widget.note}
      onPagePress={onPagePress}
      onPageChange={onPageChange}
      interactive={props.interactive}
      isRenderedFromOrg={props.isRenderedFromOrg}
    />
  );
};
